import { observable, runInAction } from 'mobx';
import {
  dataPrint,
  IWorkOrderServices,
  MoldByWorkOrder,
  ProductByMold,
  saveBarcode,
  WorkOrder,
  WorkOrderModel,
  WorkOrderDetailModel,
  WorkOrderDetail,
  StatusMes,
} from './../services/workOrder_services';
import { DataResponse } from 'services/response';

export type WorkOrderStore = {
  workOrder: DataResponse<Array<WorkOrderModel>>;
  // workOrder: {
  //   data: Array<WorkOrderModel>;
  //   message: string;
  //   isSuccess: boolean;
  //   resultsCount: number;
  //   recordsTotal: number;
  //   pagesCount: number;
  // };
  createResponse: {
    message?: string;
    isSuccess?: boolean;
  };
  getWorkOrderByIdResponse: {
    isSuccess: boolean;
    message: string;
    data: Array<WorkOrder>;
  };
  getMoldByWOResponse: {
    data: MoldByWorkOrder | undefined;
    isSuccess: boolean;
    message: string;
  };
  getProductByMoldResponse: {
    data: Array<ProductByMold>;
    isSuccess: boolean;
    message: string;
  };
  createWOMoldResponse: {
    isSuccess: boolean;
    message: string;
  };
  saveBarcodeResponse: {
    data: dataPrint | undefined;
    isSuccess: boolean;
    message: string;
  };
  getInfoSaveBarcodeResponse: {
    data: saveBarcode | undefined;
    isSuccess: boolean;
    message: string;
  };
  // Chi tiết lệnh sản xuất
  getWODetailsResponse: {
    data: WorkOrderDetailModel | undefined;
    isSuccess: boolean;
    message: string;
  };
  deleteWOMoldResponse: {
    isSuccess: boolean;
    message: string;
  };
  updateWOMoldResponse: {
    isSuccess: boolean;
    message: string;
  };
  updateProductionStatus: {
    isSuccess: boolean;
    message: string;
  };
  createWOVS: {
    isSuccess: boolean;
    message: string;
  };

  workOrderSearch: WorkOrderDetail;
};

export interface IWorkOrderPresenter {
  createStore(): WorkOrderStore;
  getListWorkOrder(store: WorkOrderStore, data: object): Promise<void>;
  getByWorkOrderId(store: WorkOrderStore, id: string): Promise<void>;
  getMoldByWO(store: WorkOrderStore, id: string): Promise<void>;
  getProductByMold(store: WorkOrderStore, productId: string): Promise<void>;
  getInfoSaveBarcode(store: WorkOrderStore, productId: string): Promise<void>;
  saveBarcode(store: WorkOrderStore, data: object): Promise<void>;
  createWOMold(store: WorkOrderStore, data: object): Promise<void>;
  // chi tiết lệnh sản xuất
  getWorkOrderDetails(store: WorkOrderStore, workOrderId: string): Promise<void>;
  deleteWOMold(store: WorkOrderStore, id: string): Promise<void>;
  updateWORouting(store: WorkOrderStore, data: object): Promise<void>;
  setStateSearch(store: WorkOrderStore, data: WorkOrderDetail): Promise<void>;
  // update trạng thái MES
  updateProductionStatus(store: WorkOrderStore, data?: StatusMes): Promise<void>;

  createWOVS(store: WorkOrderStore, data?: { description: string, workOrderType?: string, stepCode?: string }): Promise<void>;
}

export function createWorkOrderPresenter({
  workOrderServices,
}: {
  workOrderServices: IWorkOrderServices;
}): IWorkOrderPresenter {
  return {
    createStore: (): WorkOrderStore =>
      observable({
        workOrder: {
          isSuccess: false,
          message: '',
          data: [],
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        createResponse: {
          message: '',
          isSuccess: false,
        },
        getWorkOrderByIdResponse: {
          isSuccess: false,
          message: '',
          data: [],
        },
        getMoldByWOResponse: {
          data: undefined,
          isSuccess: false,
          message: '',
        },
        getProductByMoldResponse: {
          data: [],
          isSuccess: false,
          message: '',
        },
        createWOMoldResponse: {
          isSuccess: false,
          message: '',
        },
        getInfoSaveBarcodeResponse: {
          data: undefined,
          isSuccess: false,
          message: '',
        },
        saveBarcodeResponse: {
          data: undefined,
          isSuccess: false,
          message: '',
        },
        getWODetailsResponse: {
          data: undefined,
          isSuccess: false,
          message: '',
        },
        deleteWOMoldResponse: {
          isSuccess: false,
          message: '',
        },
        updateWOMoldResponse: {
          isSuccess: false,
          message: '',
        },
        updateProductionStatus: {
          isSuccess: false,
          message: '',
        },
        createWOVS: {
          isSuccess: false,
          message: '',
        },
        workOrderSearch: {
          paging: {
            pageIndex: 1,
            pageSize: 10,
            orderBy: '',
            orderByDesc: '',
          },
          productionStatusCode: '',
          productCode: '',
          workOrderCode: '',
          printStatus: '',
          estimateFromDateFrom: undefined,
          estimateFromDateTo: undefined,
          estimateDate: '',
          isUpdateMolde: null,
          documentDateFrom: undefined,
          documentDateTo: undefined,
          documentDate: 'ThisWeek',
        },
      }),
    getListWorkOrder: async (store, data) => {
      try {
        const workOrder = await workOrderServices.getListWorkOrder(data);
        runInAction(() => {
          store.workOrder.data = workOrder.data;
          store.workOrder.message = workOrder.message;
          store.workOrder.isSuccess = workOrder.isSuccess;
          // store.workOrder.pagesCount = workOrder.pagesCount;
          // store.workOrder.recordsTotal = workOrder.recordsTotal;
          // store.workOrder.resultsCount = workOrder.resultsCount;
          store.workOrder.paging = {
            totalCount: workOrder.paging?.totalCount,
            totalPage: workOrder.paging?.totalPage,
            pageSize: workOrder.paging?.pageSize,
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    createWOMold: async (store: WorkOrderStore, data: object) => {
      try {
        const result = await workOrderServices.createWOMold(data);
        runInAction(() => {
          store.createWOMoldResponse.isSuccess = result.isSuccess;
          store.createWOMoldResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },

    getByWorkOrderId: async (store: WorkOrderStore, id: string) => {
      try {
        const result = await workOrderServices.getByWorkOrderId(id);
        runInAction(() => {
          store.getWorkOrderByIdResponse.isSuccess = result.isSuccess;
          store.getWorkOrderByIdResponse.message = result.message;
          store.getWorkOrderByIdResponse.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getMoldByWO: async (store: WorkOrderStore, id: string) => {
      try {
        const result = await workOrderServices.getMoldByWO(id);
        runInAction(() => {
          store.getMoldByWOResponse.isSuccess = result.isSuccess;
          store.getMoldByWOResponse.message = result.message;
          store.getMoldByWOResponse.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getProductByMold: async (store: WorkOrderStore, productId: string) => {
      try {
        const result = await workOrderServices.getProductByMold(productId);
        runInAction(() => {
          store.getProductByMoldResponse.isSuccess = result.isSuccess;
          store.getProductByMoldResponse.message = result.message;
          store.getProductByMoldResponse.data = result.data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getInfoSaveBarcode: async (store, productId) => {
      try {
        const result = await workOrderServices.getInfoSaveBarcode(productId);
        runInAction(() => {
          store.getInfoSaveBarcodeResponse.data = result.data;
          store.getProductByMoldResponse.isSuccess = result.isSuccess;
          store.getProductByMoldResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    saveBarcode: async (store, data) => {
      try {
        const result = await workOrderServices.saveBarcode(data);
        runInAction(() => {
          store.saveBarcodeResponse.data = result.data;
          store.saveBarcodeResponse.isSuccess = result.isSuccess;
          store.saveBarcodeResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getWorkOrderDetails: async (store: WorkOrderStore, workOrderId: string) => {
      try {
        const result = await workOrderServices.getWorkOrderDetails(workOrderId);
        runInAction(() => {
          store.getWODetailsResponse.data = result.data;
          store.getWODetailsResponse.isSuccess = result.isSuccess;
          store.getWODetailsResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    deleteWOMold: async (store: WorkOrderStore, id: string) => {
      try {
        const result = await workOrderServices.deleteWOMold(id);
        runInAction(() => {
          store.deleteWOMoldResponse.isSuccess = result.isSuccess;
          store.deleteWOMoldResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    updateWORouting: async (store, data) => {
      try {
        const result = await workOrderServices.updateWORouting(data);
        runInAction(() => {
          store.updateWOMoldResponse.isSuccess = result.isSuccess;
          store.updateWOMoldResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    setStateSearch: async (store, data) => {
      try {
        runInAction(() => {
          store.workOrderSearch = data;
        });
      } catch (error) {
        console.log(error);
      }
    },
    updateProductionStatus: async (store, data) => {
      try {
        const result = await workOrderServices.updateProductionStatus(data);
        runInAction(() => {
          store.updateProductionStatus.isSuccess = result.isSuccess;
          store.updateProductionStatus.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    createWOVS: async (store, data) => {
      try {
        const result = await workOrderServices.createWOVS(data);
        runInAction(() => {
          store.createWOVS.isSuccess = result.isSuccess;
          store.createWOVS.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
